import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'accordion';

/**
 * Class Foo.
 */
export class Accordion extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  connectedCallback() {
    this.getElements();
  }

  /**
   * getElements
   */
  getElements() {
    this.accordionContent = this.querySelector('unistra-accordion-content');
    this.btn = this.querySelector('button');

    this.btn.addEventListener('click', this.onClick.bind(this));

    this.updateInert();
  }

  /**
   * Toggle `inert` on the collapsed content instead of managing tabindex on
   * a one-time snapshot of focusable descendants: `inert` also blocks
   * click/programmatic focus (which tabindex="-1" does not, leaving a
   * focusable subtree under aria-hidden="true" — WCAG 4.1.2), and it
   * applies to any descendant added later (AJAX, views) without needing to
   * re-scan.
   */
  updateInert() {
    const isHidden = this.accordionContent.getAttribute('aria-hidden') !== 'false';
    this.accordionContent.toggleAttribute('inert', isHidden);
  }

  /**
   * onClick
   */
  onClick() {
    this.accordionContent.getAttribute('aria-hidden') === 'false'
      ? this.accordionContent.setAttribute('aria-hidden', 'true')
      : this.accordionContent.setAttribute('aria-hidden', 'false');
    this.btn.getAttribute('aria-expanded') === 'false'
      ? this.btn.setAttribute('aria-expanded', 'true')
      : this.btn.setAttribute('aria-expanded', 'false');

    this.updateInert();
  }
}

export default Accordion;
